var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('div',{staticStyle:{"width":"1080px","height":"980px","background-size":"cover"},style:({ 'background-image': ("url(" + _vm.url + ")") })}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }